import PortalPage from "./portal-page"

export default PortalPage
